module.exports = __webpack_public_path__ + "static/media/SHIlogo.1e1846d8.png";